import { useNavigateWithOfflineMode } from '@hooks';
import { theme, Typography } from '@styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const GoBackButton = () => {
  const { t } = useTranslation();
  const { navigate } = useNavigateWithOfflineMode();
  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Typography
      color={theme.colors.schoolBusYellow[100]}
      fontSize={18}
      onClick={handleGoBack}
      style={{ cursor: 'pointer' }}
    >
      {'<<'} {t('General.Back')}
    </Typography>
  );
};

export default GoBackButton;
